var map = {
	"./music-instructions.json": 5051,
	"./music-library-intro2024.json": 5052,
	"./music-library-launch2024.json": 5053,
	"./music-progression.json": 5054,
	"./startSourcesAdvanced.json": 5055,
	"./startSourcesSimple.json": 5056,
	"./startSourcesSimple2.json": 5057,
	"./startSourcesTracks.json": 5058
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4817;